import { getToken } from "../auth.service"

export const createSubscription = async (data: any) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/subscriptions`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg = (json && (json.message || json.error)) || "Falha ao criar inscrição";
      throw new Error(msg);
    }
    return json;
  } catch (erro) {
    console.error(erro);
    throw erro;
  }
}

export const getUserOnly = async () => {
  try {
    const request = await fetch(`${process.env.REACT_APP_API_URL}/subscriptions/user`, {
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    })
    return await request.json();
  } catch (error) {
    return []
  }
}
